module.exports = __webpack_public_path__ + "img/21-unnc-alpha-logo.47ffe4d4.png";